import { MIMETYPE_JSON } from '@disy/lib/media-type';

import { ajax } from 'cadenza/api-client/api';
import type { DataSourceDto } from 'cadenza/api-client/dto/data-source-dto';
import { createWorkbookUrl } from 'cadenza/api-client/workbook-api';
import { Command } from 'cadenza/api-client/workbook-commands';
import type { ExternalLayerDescriptions } from 'cadenza/api-client/workbook-layer/workbook-layer-capabilities-dto';
import type { UserNamePasswordDto } from 'cadenza/model/user-name-password-dto';
import type { DataSourceId } from 'cadenza/repository/model/data-source-id.gen';
import type { WorkbookNameAndHash } from 'cadenza/repository/model/workbook-name-and-hash';
import { getStore } from 'cadenza/store/cadenza-store';
import type { LayerId } from 'cadenza/workbook/api/layer-id';
import type { ViewId } from 'cadenza/workbook/api/view-id';
import type { ExternalLayerInfoDto } from 'cadenza/workbook/model/external-layer-info-dto';
import { executeCommand } from 'cadenza/workbook/workbook-core-reducers.state';

/** @see net/disy/cadenza/workbook/web/map/wms/ExternalLayerInfosEndpointController.java */
export function getExternalLayerInfos(url: string, credentials?: UserNamePasswordDto, abortSignal?: AbortSignal) {
  return ajax<ExternalLayerInfoDto[]>('/external-layer-infos', {
    type: 'POST',
    contentType: MIMETYPE_JSON,
    data: JSON.stringify({ url, credentials }),
    signal: abortSignal,
  });
}

export function getExternalLayerInfosFromDatasource(dataSourceId: DataSourceId, abortSignal?: AbortSignal) {
  return ajax<ExternalLayerInfoDto[]>('/external-layer-infos', {
    type: 'POST',
    contentType: MIMETYPE_JSON,
    data: JSON.stringify({ dataSourceId }),
    signal: abortSignal,
  });
}

export function addExternalLayers(
  viewId: ViewId,
  externalLayers: ExternalLayerInfoDto[],
  credentials?: UserNamePasswordDto,
  parentLayerId?: LayerId,
) {
  return getStore().dispatch(
    executeCommand(
      Command.ADD_EXTERNAL_LAYERS({
        viewId,
        parentLayerId,
        externalLayers,
        credentials,
      }),
    ),
  );
}

export function changeExternalLayerCredentials(viewId: ViewId, layerId: LayerId, credentials: UserNamePasswordDto) {
  return getStore().dispatch(
    executeCommand(
      Command.CHANGE_EXTERNAL_LAYER_CREDENTIALS({
        viewId,
        layerId,
        credentials,
      }),
    ),
  );
}

export function getWorkbookLayerDescriptions(workbookNameAndHash: WorkbookNameAndHash, viewId: string) {
  return ajax<ExternalLayerDescriptions>(
    `${createWorkbookUrl(workbookNameAndHash)}/views/${viewId}/external-layer-descriptions`,
  );
}

export function getAllExternalLayerDatasources(srs?: string) {
  const urlParams = new URLSearchParams({
    privileges: '',
  });
  if (srs) {
    urlParams.append('srs', srs);
  }
  urlParams.append('type', 'OGC_RASTER');
  urlParams.append('type', 'VECTOR_TILES');
  urlParams.append('type', 'ARCGIS_RASTER');

  return ajax<DataSourceDto[]>(`/datasources?${urlParams}`, { dataType: 'json' });
}
